<script lang="ts" setup>
import { PhPlayCircle } from '@phosphor-icons/vue'
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'

import {
  AdvertorialBadge,
  Figure,
  Picture,
  SectionTitleHeading,
  Teaser,
  TeaserContent
} from '@toni/brand-ui'
import { useConfigStore } from '@toni/rendering/src/stores/config'
import { usePageStore } from '@toni/rendering/src/stores/page'

import { Badge } from '../../../ui/article-header/index.ts'

const pageStore = usePageStore()
const brand = computed(() => pageStore.brandFromStore as string)

const configStore = useConfigStore()
const rsConfig = ref(configStore.rsConfig)
const commonProps = computed(() => ({
  brand: brand.value,
  sizes: '100vw'
}))

const { t } = useI18n()

defineProps<{
  item: TeaserItem // This type doesn't exist anymore :/
}>()

const headingType = computed(() => {
  return pageStore.pageData?.pageMeta?.pageType === 'structureterm' ? 'h2' : 'div'
})

const advertorialBadgeStyleClasses = computed(() => {
  return {
    'absolute text-badge-advertisement text-foreground px-1 py-0.5 z-10 bg-background opacity-80 lowercase first-letter:uppercase top-2 2xl:top-3 right-2 2xl:right-3': true
  }
})
</script>

<template>
  <Teaser :key="item.assetId"
          class="sm:basis-1/4"
          :variant="'teaser-group-quadruple'"
          :href="item.url ?? '#'"
          :target="item.target || '_self'"
          :rel="item.rel || 'noopener noreferrer'">
    <Figure class="basis-1/2 sm:flex-none">
      <AdvertorialBadge v-if="item.advertorial"
                        :class="advertorialBadgeStyleClasses">
        {{ t('ads.advertorialBadge') }}
      </AdvertorialBadge>
      <Picture>
        <img :src="`${rsConfig.imageServiceUrl}/image,id=${item.imageId},b=${commonProps.brand},w=1280,h=720,rm=sk.webp`"
             :alt="item.imageAltText || ''"
             class="object-cover w-full h-full rounded-image">
      </Picture>
      <div v-if="item.hasAutoPlay"
           class="absolute bottom-7 right-4 h-8 w-9 z-10 bg-white flex items-center justify-center">
        <PhPlayCircle class="w-6 h-6" />
      </div>
    </Figure>
    <TeaserContent :variant="'teaser-group-quadruple'"
                   class="top-0 sm:-top-3.5 px-3 lg:px-5">
      <Badge v-if="item.roofline || item.mainStructureName"
             type="text"
             variant="tertiary"
             class="md:text-badge-md text-badge-sm uppercase px-2 pt-1 pb-[3px]">
        {{ item.roofline || item.mainStructureName }}
      </Badge>
      <SectionTitleHeading v-if="item.titleShort || item.titleLong"
                           :heading-type="headingType">
        {{ item.titleShort || item.titleLong }}
      </SectionTitleHeading>
    </TeaserContent>
  </Teaser>
</template>
